import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.menuItem.subItems && !_vm.menuItem.hidden
        ? _c(
            VListItem,
            {
              key: _vm.menuItem.link,
              attrs: {
                "input-value": _vm.menuItem.value,
                to: _vm.menuItem.link,
                exact: _vm.menuItem.exact,
                disabled: _vm.menuItem.disabled,
                link: "",
                name: _vm.menuItem.href.name,
                id: _vm.menuItem.href.name,
              },
              on: {
                mouseover: function ($event) {
                  _vm.isHover = true
                },
                mouseleave: function ($event) {
                  _vm.isHover = false
                },
              },
            },
            [
              _c(
                VListItemIcon,
                { class: { "ml-1": _vm.sinIcono } },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var attrs = ref.attrs
                              var on = ref.on
                              return [
                                _c(
                                  VIcon,
                                  _vm._g(
                                    _vm._b(
                                      {
                                        class: {
                                          "grey--text": _vm.menuItem.disabled,
                                        },
                                        attrs: { small: _vm.small },
                                      },
                                      "v-icon",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.menuItem.icon ||
                                            "mdi-circle-medium"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1392282224
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.menuItem.key
                              ? _vm.$t(_vm.menuItem.key)
                              : _vm.menuItem.name
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(VListItemTitle, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.menuItem.key
                            ? _vm.$t(_vm.menuItem.key)
                            : _vm.menuItem.name
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.menuItem.subItems && !_vm.menuItem.hidden
        ? _c(
            VListGroup,
            {
              key: _vm.menuItem.link,
              attrs: {
                disabled: _vm.menuItem.disabled,
                "sub-group": _vm.subgroup,
                to: _vm.menuItem.link,
                link: "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function () {
                      return [
                        !_vm.subgroup
                          ? _c(
                              VListItemIcon,
                              [
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var attrs = ref.attrs
                                            var on = ref.on
                                            return [
                                              _c(
                                                VIcon,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        small: _vm.small,
                                                      },
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.menuItem.icon ||
                                                        "mdi-circle-medium"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      533892344
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.menuItem.key
                                            ? _vm.$t(_vm.menuItem.key)
                                            : _vm.menuItem.name
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.menuItem.visible) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          VListItemContent,
                          [
                            _c(VListItemTitle, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.menuItem.key
                                      ? _vm.$t(_vm.menuItem.key)
                                      : _vm.menuItem.name
                                  ) +
                                  " "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1227259877
              ),
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }